// extracted by mini-css-extract-plugin
module.exports = {"AuthorSlider":"AuthorSlider_AuthorSlider__K_91g"};